import './index.scss';
import React, { ReactNode, PureComponent } from 'react';
import { Helmet } from 'react-helmet';
import { Layout } from 'antd';
import { getPartnerInfo } from '../../utils/bookingUtil';

interface PageLayoutProps {
  title: string;
  salonId: number;
  children: ReactNode;
  containerProps?: any;
  standalone?: boolean;
}

class PageLayout extends PureComponent<PageLayoutProps> {
  render() {
    const { title = 'Booking', salonId, standalone, children, containerProps } = this.props;
    const partner = getPartnerInfo(salonId);

    return (
      <>
        <Helmet>
          <title>{title}</title>
        </Helmet>

        <Layout className="app--layout" {...containerProps}>
          {partner && standalone && (
            <Layout.Header className="app--header">
              <div className="fave-layout--container">
                <div className="partner">
                  <div className="partner-logo">
                    <img src={partner.logo} alt={partner.name} />
                  </div>

                  <div className="partner-info">
                    <div className="partner-name">
                      {partner.name}
                    </div>
                    <div className="partner-address">
                      {partner.address}
                    </div>
                  </div>
                </div>
              </div>
            </Layout.Header>
          )}

          <Layout.Content className="app--content">
            {children}
          </Layout.Content>
        </Layout>
      </>
    );
  }
}

export default PageLayout;
